module.exports = __webpack_public_path__ + "static/media/question_mark_icon.cd1cb7a9.svg";